"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.variativeTranslationCheck = exports.formatDisplayDuration = exports.parseDuration = exports.convertInputDuration = void 0;
const fast_memoize_1 = __importDefault(require("fast-memoize"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const date_fns_1 = require("date-fns");
const number_1 = require("../helpers/number");
const intl_1 = require("../locale/intl");
const texts_1 = require("../texts");
const moment_duration_format_1 = __importDefault(require("moment-duration-format"));
(0, moment_duration_format_1.default)(moment_timezone_1.default);
const secondsTxt = (0, intl_1.$t)(texts_1.durationFieldText.seconds);
const secondTxt = (0, intl_1.$t)(texts_1.durationFieldText.second);
const minuteTxt = (0, intl_1.$t)(texts_1.durationFieldText.minute);
const minutesTxt = (0, intl_1.$t)(texts_1.durationFieldText.minutes);
const hrTxt = (0, intl_1.$t)(texts_1.durationFieldText.hr);
const hrsTxt = (0, intl_1.$t)(texts_1.durationFieldText.hrs);
const hourTxt = (0, intl_1.$t)(texts_1.durationFieldText.hour);
const hoursTxt = (0, intl_1.$t)(texts_1.durationFieldText.hours);
const dayTxt = (0, intl_1.$t)(texts_1.durationFieldText.day);
const daysTxt = (0, intl_1.$t)(texts_1.durationFieldText.days);
const secTxt = (0, intl_1.$t)(texts_1.durationFieldText.sec);
const secsTxt = (0, intl_1.$t)(texts_1.durationFieldText.secs);
const minTxt = (0, intl_1.$t)(texts_1.durationFieldText.min);
const minsTxt = (0, intl_1.$t)(texts_1.durationFieldText.mins);
const sTxt = (0, intl_1.$t)(texts_1.durationFieldText.s);
const mTxt = (0, intl_1.$t)(texts_1.durationFieldText.m);
const hTxt = (0, intl_1.$t)(texts_1.durationFieldText.h);
const dTxt = (0, intl_1.$t)(texts_1.durationFieldText.d);
const convertInputDuration = (fieldValue, defaultValue = 0) => {
    if (!fieldValue) {
        return defaultValue;
    }
    let lastValidDuration = defaultValue;
    for (let i = 1; i <= fieldValue.length; i++) {
        const value = fieldValue.slice(0, i);
        const duration = (0, exports.parseDuration)(value, defaultValue);
        if (duration > 0) {
            lastValidDuration = duration;
        }
    }
    return lastValidDuration;
};
exports.convertInputDuration = convertInputDuration;
const parseDuration = (fieldValue, defaultValue = 0) => {
    var _a;
    try {
        // This allows to parse from a number of standard Duration formats including ISO 8601 used in iCAL files
        const withMoment = moment_timezone_1.default.duration(fieldValue, "minute").asSeconds();
        if (withMoment > 0) {
            return withMoment;
        }
        const cleanValue = fieldValue.replace(/,|\.`|~|!|@|#|\$|%|\^|&|\*|\(|\)|\+|=|\[|{|]|}|\||\\|'|<|>|\?|\/|""|;|:|\n/gi, "");
        const values = (_a = cleanValue.match(/[^0-9|.\s]+|[0-9.]+/gi)) !== null && _a !== void 0 ? _a : [];
        let duration = defaultValue;
        let unit = null;
        let value = null;
        values.forEach((element) => {
            if (!value && value !== 0) {
                value = Number(element.trim());
                if (!value && value !== 0) {
                    unit = element.trim();
                    value = null;
                }
            }
            else {
                unit = element.trim();
            }
            if ((!!value || value === 0) && unit) {
                duration += extractSecondsFromInput(unit, value);
                value = null;
                unit = null;
            }
        });
        return duration;
    }
    catch (e) {
        return 0;
    }
};
exports.parseDuration = parseDuration;
/**
 * Returns duration object according to input value
 * @param milliseconds  count of milliseconds
 */
const millisecondsToDuration = (milliseconds) => {
    let restMilliseconds = milliseconds;
    const dayMs = 86400; // 24 * 60 * 60
    const hourMs = 3600; // 60 * 60
    const minuteMs = 60;
    const days = Math.floor(restMilliseconds / dayMs);
    restMilliseconds -= days * dayMs;
    const hours = Math.floor(restMilliseconds / hourMs);
    restMilliseconds -= hours * hourMs;
    const minutes = Math.floor(restMilliseconds / minuteMs);
    restMilliseconds -= minutes * minuteMs;
    const seconds = restMilliseconds;
    return { days, hours, minutes, seconds };
};
const formatDisplayDuration = (fieldValue, displayFormat, pattern, // "dd:hh:mm:ss"
formatZeroValue = false) => {
    var _a, _b, _c;
    if (!(0, number_1.isNumber)(fieldValue) ||
        isNaN(fieldValue) ||
        (!fieldValue && fieldValue !== 0) ||
        (fieldValue === 0 && !formatZeroValue)) {
        return "";
    }
    let durationPattern = pattern;
    if (displayFormat === "mixed") {
        durationPattern = durationPattern.replace(":ss", "");
    }
    let formatLocale;
    let delimiter = " ";
    let duration = millisecondsToDuration(fieldValue);
    duration = collapseDuration(duration, durationPattern);
    switch (displayFormat) {
        case "compact":
            formatLocale = {
                xDays: `{{count}}${dTxt}`,
                xHours: `{{count}}${hTxt}`,
                xMinutes: `{{count}}${mTxt}`,
                xSeconds: `{{count}}${sTxt}`,
            };
            break;
        case "long":
            formatLocale = {
                xDays: `{{count}} ${duration.days === 1 ? dayTxt : daysTxt}`,
                xHours: `{{count}} ${duration.hours === 1 ? hourTxt : hoursTxt}`,
                xMinutes: `{{count}} ${duration.minutes === 1 ? minuteTxt : minutesTxt}`,
                xSeconds: `{{count}} ${duration.seconds === 1 ? secondTxt : secondsTxt}`,
            };
            break;
        case "mixed":
            formatLocale = {
                xHours: `{{count}}${hTxt}`,
                xMinutes: `{{count}} ${minTxt}`,
            };
            break;
        case "hours_minutes_seconds":
            duration.hours = (_a = duration.hours) !== null && _a !== void 0 ? _a : 0;
            duration.minutes = (_b = duration.minutes) !== null && _b !== void 0 ? _b : 0;
            duration.seconds = (_c = duration.seconds) !== null && _c !== void 0 ? _c : 0;
            formatLocale = {
                xHours: duration.hours.toString().padStart(2, "0"),
                xMinutes: duration.minutes.toString().padStart(2, "0"),
                xSeconds: duration.seconds.toString().padStart(2, "0"),
            };
            delimiter = ":";
            break;
        default:
            formatLocale = {
                xDays: `{{count}} ${dTxt}`,
                xHours: `{{count}} ${duration.hours === 1 ? hrTxt : hrsTxt}`,
                xMinutes: `{{count}} ${duration.minutes === 1 ? minTxt : minsTxt}`,
                xSeconds: `{{count}} ${duration.seconds === 1 ? secTxt : secsTxt}`,
            };
            break;
    }
    const locale = {
        formatDistance: (token, count) => {
            var _a;
            return (_a = formatLocale[token]) === null || _a === void 0 ? void 0 : _a.replace("{{count}}", count);
        },
    };
    return (0, date_fns_1.formatDuration)(duration, {
        format: Object.keys(duration).sort(),
        locale,
        delimiter,
        zero: true,
    });
};
exports.formatDisplayDuration = formatDisplayDuration;
const getPatternValues = (0, fast_memoize_1.default)((pattern) => {
    return new Set(pattern.toLocaleLowerCase().split(":"));
});
const collapseDuration = (duration, pattern) => {
    var _a;
    const patternValues = getPatternValues(pattern);
    let collapsedDuration = {
        days: duration === null || duration === void 0 ? void 0 : duration.days,
        hours: duration === null || duration === void 0 ? void 0 : duration.hours,
        minutes: duration === null || duration === void 0 ? void 0 : duration.minutes,
        seconds: duration === null || duration === void 0 ? void 0 : duration.seconds,
    };
    collapsedDuration.days = (_a = collapsedDuration.days) !== null && _a !== void 0 ? _a : 0;
    collapsedDuration = calculateEdgeTime(collapsedDuration, patternValues);
    collapsedDuration = moveLeadingTime(collapsedDuration, patternValues);
    collapsedDuration = removeNonSignificantTime(collapsedDuration, patternValues);
    return collapsedDuration;
};
const calculateEdgeTime = (duration, patternValues) => {
    var _a, _b, _c;
    if (!patternValues.has("ss") && duration.seconds && duration.seconds >= 30) {
        duration.minutes = (_a = duration.minutes) !== null && _a !== void 0 ? _a : 0;
        duration.minutes += 1;
    }
    if (!patternValues.has("mm") && duration.minutes && duration.minutes >= 30) {
        duration.hours = (_b = duration.hours) !== null && _b !== void 0 ? _b : 0;
        duration.hours += 1;
    }
    if (!patternValues.has("hh") && duration.hours && duration.hours >= 12) {
        duration.days = (_c = duration.days) !== null && _c !== void 0 ? _c : 0;
        duration.days += 1;
    }
    return duration;
};
const moveLeadingTime = (duration, patternValues) => {
    var _a, _b, _c, _d, _e, _f;
    if (!patternValues.has("dd")) {
        duration.hours = (_a = duration.hours) !== null && _a !== void 0 ? _a : 0;
        duration.hours += ((_b = duration.days) !== null && _b !== void 0 ? _b : 0) * 24;
    }
    if (!patternValues.has("hh")) {
        duration.minutes = (_c = duration.minutes) !== null && _c !== void 0 ? _c : 0;
        duration.minutes += (0, date_fns_1.hoursToMinutes)((_d = duration.hours) !== null && _d !== void 0 ? _d : 0);
    }
    if (!patternValues.has("mm")) {
        duration.seconds = (_e = duration.seconds) !== null && _e !== void 0 ? _e : 0;
        duration.seconds += (0, date_fns_1.minutesToSeconds)((_f = duration.minutes) !== null && _f !== void 0 ? _f : 0);
    }
    return duration;
};
const removeNonSignificantTime = (duration, patternValues) => {
    const needRemoveEmptyDays = duration.days === 0 &&
        (patternValues.has("hh") ||
            patternValues.has("mm") ||
            patternValues.has("ss"));
    if (!patternValues.has("dd") || needRemoveEmptyDays) {
        delete duration.days;
    }
    const needRemoveEmptyHours = duration.hours === 0 &&
        !duration.days &&
        (patternValues.has("mm") || patternValues.has("ss"));
    if (!patternValues.has("hh") || needRemoveEmptyHours) {
        delete duration.hours;
    }
    const needRemoveEmptyMinutes = duration.minutes === 0 &&
        !duration.days &&
        !duration.hours &&
        patternValues.has("ss");
    if (!patternValues.has("mm") || needRemoveEmptyMinutes) {
        delete duration.minutes;
    }
    if (!patternValues.has("ss")) {
        delete duration.seconds;
    }
    return duration;
};
const variativeTranslationCheck = (value) => {
    const lowerCasedValue = value.toLowerCase();
    return (translation) => lowerCasedValue === translation.toLocaleLowerCase();
};
exports.variativeTranslationCheck = variativeTranslationCheck;
const extractSecondsFromInput = (unit, value) => {
    const memoizedUnitTranslation = (0, exports.variativeTranslationCheck)(unit);
    if (memoizedUnitTranslation(secondsTxt) ||
        memoizedUnitTranslation(secondTxt) ||
        memoizedUnitTranslation(secsTxt) ||
        memoizedUnitTranslation(secTxt) ||
        memoizedUnitTranslation(sTxt)) {
        return moment_timezone_1.default.duration({ seconds: value }).asSeconds();
    }
    if (memoizedUnitTranslation(secondsTxt) ||
        memoizedUnitTranslation(minuteTxt) ||
        memoizedUnitTranslation(minutesTxt) ||
        memoizedUnitTranslation(minsTxt) ||
        memoizedUnitTranslation(minTxt) ||
        memoizedUnitTranslation(mTxt)) {
        return moment_timezone_1.default.duration({ minutes: value }).asSeconds();
    }
    if (memoizedUnitTranslation(hoursTxt) ||
        memoizedUnitTranslation(hourTxt) ||
        memoizedUnitTranslation(hrsTxt) ||
        memoizedUnitTranslation(hrTxt) ||
        memoizedUnitTranslation(hTxt)) {
        return moment_timezone_1.default.duration({ hours: value }).asSeconds();
    }
    if (memoizedUnitTranslation(daysTxt) ||
        memoizedUnitTranslation(dayTxt) ||
        memoizedUnitTranslation(dTxt)) {
        return moment_timezone_1.default.duration({ days: value }).asSeconds();
    }
    return 0;
};
